import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { usePublishedNews } from "../../lib/publishedNews";
import { useHomeLimits } from "../../lib/homeLimits";
import { ROUTES } from "../../lib/routes";

/**
 * webadmin's published news posts, as published (see publishedNews.ts), the
 * most recently published first, up to webadmin's home `maxNews` (see
 * homeLimits.ts). Neither `featured` nor display order is consulted: unlike the
 * Campus Events rail and the news page, the home page shows what's newest, and
 * a new post reaches it without anyone ticking `featured`. Left out of the
 * page when nothing is published.
 *
 * section--flush: it follows Campus Events (or Campus Life, when no event is
 * featured) on the same background, so that section's bottom padding is the
 * gap and this one adds none above itself.
 */
export function FeaturedNews() {
  const all = usePublishedNews().posts;
  const { maxNews } = useHomeLimits();
  const posts = [...all]
    .sort((a, b) => Date.parse(b.publishedAt) - Date.parse(a.publishedAt))
    .slice(0, maxNews);
  if (posts.length === 0) return null;

  return (
    <section className="section section--flush">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="kicker">What's new</div>
            <h2>News</h2>
          </div>
          <Link className="btn-link" to={ROUTES.news}>
            All news <span className="arr">→</span>
          </Link>
        </div>
        <div className="events-grid">
          {posts.map((p) => (
            <Link key={p.slug} to={`${ROUTES.news}/${p.slug}`} className="event-card reveal">
              {p.cover && (
                <Figure media={p.cover} fallbackLabel={p.title} aspect="16/10" sizes="(max-width: 900px) 100vw, (max-width: 1100px) 48vw, 23vw" />
              )}
              <div className="event-body">
                <div className="event-meta">
                  {p.category && <span className="event-tag">{p.category}</span>}
                  <span className="event-date">
                    {p.date.day} {p.date.month} {p.date.year}
                  </span>
                </div>
                <h4>{p.title}</h4>
                <div className="news-card-teaser">{p.summary || p.content}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
